import React, { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase/config';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [redirecting, setRedirecting] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    try {
      const actionCodeSettings = {
        url: 'https://vaultize.com/reset-confirm',
        handleCodeInApp: false,
      };

      await sendPasswordResetEmail(auth, email, actionCodeSettings);
      setMessage('Reset link sent. Redirecting to login...');
      setError('');
      setRedirecting(true);

      setTimeout(() => {
        window.location.href = '/login';
      }, 3000);
    } catch (err) {
      setError(err.message || 'Something went wrong.');
      setMessage('');
    }
  };

  return (
    <form onSubmit={handleReset} className="auth-form">
      <div className="auth-form-header">
        <h2>Forgot your password?</h2>
        <p>
          Enter your registered email address and we’ll send you a reset link.
        </p>
      </div>

      {message && <div className="auth-message success">{message}</div>}
      {error && <div className="auth-message error">{error}</div>}

      <div className="auth-field">
        <label>Email address</label>
        <input
          type="email"
          placeholder="you@company.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <button type="submit" disabled={redirecting}>
        {redirecting ? 'Redirecting…' : 'Send reset link'}
      </button>

      <div className="auth-footer">
        <a href="/login">Back to login</a>
      </div>
    </form>
  );
};

export default ForgotPassword;
